import React from "react";

const StatsDashboard = () => {
    return <div>Displays</div>;
};

export default StatsDashboard;
